import React from "react";
import { Col, Row } from "react-bootstrap";
import { FaInstagram, FaThreads, FaXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";
import "./css/Footer.css"
import { FaLinkedin, FaTelegram, FaTiktok, FaTumblr, FaYoutube } from "react-icons/fa";
import config from "../../config/config";

export default function DashboardFooter() {
    return (
        <>
            <footer className="des_footer mt-4">
                <Row className="align-items-center">
                    <Col lg={9}>
                        <div className="d-block d-lg-flex justify-content-center justify-content-lg-start links">
                            <div className="text-center text-lg-start">
                                <a href={`${config.baseUrl}about`} target="_blank" rel="noreferrer noopener">About Us</a>
                            </div>

                            <div className="text-center text-lg-start">
                                <a href={`${config.baseUrl}contact`} target="_blank" rel="noreferrer noopener">Contact</a>
                            </div>

                            <div className="text-center text-lg-start">
                                <a href="https://infimultichain.com/ico/blog" target="_blank" rel="noreferrer noopener">Blog</a>
                            </div>

                            <div className="text-center text-lg-start">
                                <a href={`${config.baseUrl}privacypolicy`} target="_blank" rel="noreferrer noopener">Privacy Policy</a>
                            </div>
                        </div>
                    </Col>
                    <Col lg={3}>
                        <div className="icons_wrapper d-flex justify-content-center justify-content-lg-end mt-3 mt-lg-0">
                        <a
                            href="https://www.linkedin.com/showcase/infi-multichain-cdex/?viewAsMember=true"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            <FaLinkedin />
                        </a>
                        <a
                            href="https://www.youtube.com/@INFIMultiChainCDEX"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            <FaYoutube />
                        </a>
                        <a href="https://x.com/INFI_MultiChain" 
                        target="_blank"
                        rel="noreferrer noopener"
                        >
                            <FaXTwitter />
                        </a>
                        <a href="https://www.tiktok.com/@infimultichain8?_t=ZN-8uGNQNTIXsU&_r=1" 
                        target="_blank"
                        rel="noreferrer noopener"
                        >
                            <FaTiktok />
                        </a>
                        <a href="https://www.instagram.com/infimultichain_official/"
                        target="_blank"
                        rel="noreferrer noopener"
                        >
                            <FaInstagram />
                        </a>
                        <a href="https://www.threads.net/@inverted_investment" 
                        target="_blank"
                        rel="noreferrer noopener"
                        >
                            <FaThreads />
                        </a>
                        <a href="https://www.tumblr.com/infimultichain?source=share" 
                        target="_blank"
                        rel="noreferrer noopener"
                        >
                            <FaTumblr />
                        </a>
                        <a
                            href="https://t.me/InvertedInvestmentOfficialGroup"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            <FaTelegram />
                        </a>
                        </div>
                    </Col>
                </Row>
            </footer>
        </>
    )
}